import { render, staticRenderFns } from "./PopupBanner.vue?vue&type=template&id=e71ea81a&scoped=true&"
import script from "./PopupBanner.vue?vue&type=script&lang=js&"
export * from "./PopupBanner.vue?vue&type=script&lang=js&"
import style0 from "./PopupBanner.vue?vue&type=style&index=0&id=e71ea81a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e71ea81a",
  null
  
)

export default component.exports